export default "__VITE_ASSET__cbdc4f72__"